// Match the native allowlist. Preview/local invitations never switch to production.
export function nativeInvitationURL(roomCode, origin) {
    if (typeof roomCode !== 'string' || !/^[A-Z0-9]{8,10}$/u.test(roomCode)) return null;
    let url;
    try { url = new URL(origin); } catch { return null; }
    const remote = ['digits.toganostudio.com', 'secret-digits-preview.byenar1isme.workers.dev'].includes(url.hostname);
    const local = ['127.0.0.1', 'localhost'].includes(url.hostname);
    if (url.username || url.password || url.search || url.hash || url.pathname !== '/') return null;
    if (!(remote && url.protocol === 'https:' && !url.port) && !(local && url.protocol === 'http:')) return null;
    return `secretdigits://${url.host}/join/${roomCode}`;
}

// A display hint only: never infer installation or restrict web participation.
export function canShowIOSAppLink(device = typeof navigator === 'undefined' ? null : navigator) {
    const userAgent = device?.userAgent;
    if (typeof userAgent !== 'string' || /Android/iu.test(userAgent)) return false;
    if (/iPhone|iPad|iPod/iu.test(userAgent)
        || /^(iPhone|iPad|iPod)$/iu.test(device.platform ?? '')) return true;
    // iPadOS desktop browsing reports a Mac platform and a Macintosh UA.
    return /Macintosh/iu.test(userAgent) && device.platform === 'MacIntel'
        && Number.isFinite(device.maxTouchPoints) && device.maxTouchPoints > 1;
}
